import React from "react";

export const BasicInput = ({ type, placeholder, value, onChange, disabled }) => {
  return (
    <div className="basicInput">
      <input type={type} placeholder={placeholder} value={value} onChange={onChange} size="1" disabled={disabled ? true : false} />
    </div>
  )
}